import React, { useState, useContext, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { login as loginSvc } from '../services/auth';
import { AuthContext } from '../context/AuthContext';
import '../styles/Login.css';
import { LoginRequest } from '../types';

export default function Login() {
    const [form, setForm] = useState<LoginRequest>({
        username: '',
        password: '',
    });
    const [error, setError] = useState<string>('');
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setError('');
        try {
            const data = await loginSvc(form);
            login(data);
            navigate('/dashboard');
        } catch (err: any) {
            setError(err.response?.data?.message || err.message);
        }
    };

    return (
        <div className="login-container">
            <form className="login-form" onSubmit={handleSubmit}>
                <h2>Login</h2>
                {error && <div className="login-form__error">{error}</div>}
                <label>
                    Username
                    <input
                        type="text"
                        name="username"
                        value={form.username}
                        onChange={handleChange}
                        required
                    />
                </label>
                <label>
                    Password
                    <input
                        type="password"
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        required
                    />
                </label>
                <button type="submit">Log In</button>
            </form>
        </div>
    );
}
